<template>
  <div>
    <van-nav-bar
      title="科室选择"
      left-arrow
      @click-left="onClickLeft"
    />
<!--  -->
    
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell v-for = "(sname,sindex) in dat" :key="sindex" :title="sname" clickable @click="cha(sindex)">
            
          </van-cell>
          
        </van-cell-group>
      </van-radio-group>
    
  </div>
</template>

<script>
import { NavBar , RadioGroup, Radio} from 'vant';

export default {
  data(){
    return{
      radio:'1',
      dat:["hehe","haha"]
    }
  },
  components:{
    [NavBar.name]:NavBar,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    cha(s) {
      alert(s);
    }
  }
}
</script>

<style>
.van-nav-bar{
  background:#456;
}
.van-nav-bar__title{
  color:#fff;
}
</style>